"use client";

import { BookmarkV2Response } from "@/api/bookmarks";
import { bookmarkClipSharesOptions } from "@/queryOptions/bookmarkClipShares";
import { Box } from "@mui/material";
import ClipShareDisplay from "./clipShareDisplay";
import CloverleafLoading from "@/stories/CloverleafLoading";
import { NoClipSharesDisplay } from "./noClipSharesDisplay";
import { useQuery } from "@tanstack/react-query";
import { FieldsBuilder } from "@/api/paramsBuilders/fields";

export default function BookmarkDisplay({ row: rowProp, backgroundColor }: { row: BookmarkV2Response, backgroundColor: string }) {
  const options = bookmarkClipSharesOptions(
    rowProp.id,
    new FieldsBuilder(
      [
        "id",
        "title",
        "meeting_id",
        "bookmark_id",
        "transcript_doc_id",
        "thumbnail_url",
        "creator_email",
        "description",
        "start_time_in_seconds",
        "tagged_users",
        "keyword",
      ]),
    );

  const { data: clipShares, isLoading } = useQuery(options);

  if (isLoading) {
    return (
      <Box className="p-4 flex items-center justify-center" style={{ backgroundColor }}>
        <CloverleafLoading className="w-16 h-16" />
      </Box>
    );
  }

  if (clipShares?.clip_shares.length === 0) {
    return (
      <NoClipSharesDisplay backgroundColor={backgroundColor} />
    );
  }

  return (
    <Box className="p-4 space-y-2" style={{ backgroundColor }}>
      {clipShares?.clip_shares.map((clipShare) => {
        const props = { ...clipShare, bookmark_id: rowProp.id };
        return (
          <ClipShareDisplay key={clipShare.id} is_owner={rowProp.is_owner} {...props} />
        )
      })}
    </Box>
  );
};